import { CCUS061Handler } from "../handler/HandlerImpl";
import { ColumnsType } from "antd/es/table";
import {
  TableIssueAuthenType,
  TableTechnicianInfoType,
} from "../../entity/Entity";
import { Checkbox, Form, Input } from "antd";

import SortTable from "../../../../../common/components/sort-table/SortTable";
import { AUTHENTICATION_KEY } from "../../constants";
import IconInfoRed from "../../../../../assets/icons/icon-info-red.svg";
import { getExpirationDateCcus061 } from "../../../../OM/OM002/presenter/ui/MemberTable";
import helpers from "../../../../../common/helpers/common";
import {
  RowErrorStore,
  useRowErrors,
} from "../handler/rowErrorStore";

/**
 * Mỗi cell tự subscribe vào lỗi của đúng dòng mình qua store ngoài React state,
 * nên gõ ở dòng này không làm các dòng khác render lại.
 */
const InputCell = ({
  store,
  rowKey,
  field,
  disabled,
  width,
  maxLength,
  placeholder,
  onInput,
}: {
  store: RowErrorStore;
  rowKey: string | number;
  field: string;
  disabled: boolean;
  width: number | string;
  maxLength?: number;
  placeholder?: string;
  onInput?: (e: any) => void;
}) => {
  const error = useRowErrors(store, rowKey)[field] ?? "";

  return (
    <Form.Item
      name={[`record${rowKey}`, field]}
      className="input-ccus062-container"
      style={{
        paddingTop: 8,
        paddingLeft: 8,
      }}
      help={error}
      validateStatus={error ? "error" : ""}
    >
      <Input
        disabled={disabled}
        size="large"
        className="input-ccus062"
        style={{ width }}
        maxLength={maxLength}
        placeholder={placeholder}
        onInput={onInput}
      />
    </Form.Item>
  );
};

const FullNameCell = ({
  store,
  rowKey,
  fullName,
  disabled,
}: {
  store: RowErrorStore;
  rowKey: string | number;
  fullName?: string;
  disabled: boolean;
}) => {
  const error = useRowErrors(store, rowKey).fullName ?? "";

  return (
    <Form.Item
      className="input-ccus062-container"
      style={{
        paddingTop: 8,
        paddingLeft: 8,
      }}
      help={error}
      validateStatus={error ? "error" : ""}
    >
      <div
        className={disabled ? "text-table-ccus-disable" : "text-table-ccus"}
        style={{ paddingTop: 8, width: 160 }}
      >
        {fullName || "-"}
      </div>
    </Form.Item>
  );
};

export const COLUMN = (handler: CCUS061Handler) => {
  const sortType = handler.sortType
  const sortBy = handler.sortBy

  const columnsTab1: ColumnsType<TableTechnicianInfoType> = [
    {
      title: "No",
      dataIndex: "No",
      width: 230,
      render: (text) => <div className="text-table-ccus">{text}</div>,
    },
    {
      title: (
        <SortTable
          columnTitle="技能者名"
          sortOrder={handler.funcCheckSortOrder("fullName", sortType, sortBy)}
          onChange={(sortOrder) => handler.funcSortTable("fullName", sortOrder)}
          justifyContent="start"
        />
      ),
      dataIndex: "fullName",
      render: (_, record) => (
        <div
          className="text-table-ccus"
          style={{ color: "#605BFF", cursor: "pointer" }}
          onClick={() => handler.openPopupDetail(record.key)}
        >
          {record.fullName}
        </div>
      ),
      width: 238,
    },
    {
      title: (
        <SortTable
          columnTitle="部門"
          sortOrder={handler.funcCheckSortOrder("group", sortType, sortBy)}
          onChange={(sortOrder) => handler.funcSortTable("group", sortOrder)}
          justifyContent="start"
        />
      ),
      dataIndex: "group",
      render: (text) => <div className="text-table-ccus">{text}</div>,
      width: 238,
    },
    {
      title: "技能者ID",
      dataIndex: "ccusId",
      render: (text) => (
        <div className="text-table-ccus">
          {helpers.convertToCCUSFormat(text || "")}
        </div>
      ),
      width: 238,
    },
    {
      title: (
        <SortTable
          columnTitle="有効期限"
          sortOrder={handler.funcCheckSortOrder(
            "ccusExpiredDate",
            sortType,
            sortBy
          )}
          onChange={(sortOrder) =>
            handler.funcSortTable("ccusExpiredDate", sortOrder)
          }
          justifyContent="start"
        />
      ),
      dataIndex: "expiredDate",
      render: (text) => (
        <div className="text-table-ccus">
          {text ? getExpirationDateCcus061(text) : "-"}
        </div>
      ),
      width: 238,
    },
  ];

  const columnsTab2: ColumnsType<TableIssueAuthenType> = [
    {
      title: (
        <SortTable
          columnTitle="技能者ID"
          sortOrder={handler.funcCheckSortOrder("ccusId", sortType, sortBy)}
          onChange={(sortOrder) => handler.funcSortTable("ccusId", sortOrder)}
          justifyContent="start"
        />
      ),
      render: (_, record) => {
        return (
          <div style={{ paddingTop: 16, paddingLeft: 8 }}>
            <span
              className={
                record.state === AUTHENTICATION_KEY[1].key
                  ? "text-table-ccus-disable"
                  : "text-table-ccus"
              }
            >
              {record.ccusId}
            </span>
            <Form.Item
              name={[`record${record.key}`, `ccusId`]}
              hidden
              style={{ display: "none" }}
            >
              <Input
                disabled={record.state === AUTHENTICATION_KEY[1].key}
                size="large"
                className="input-ccus062"
              />
            </Form.Item>
            {/* 本人確認番号 đã bỏ khỏi giao diện nhưng vẫn phải đăng ký field,
                nếu không getFieldsValue() sẽ bỏ qua và payload gửi lên rỗng */}
            <Form.Item
              name={[`record${record.key}`, `confirmCode`]}
              hidden
              style={{ display: "none" }}
            >
              <Input
                disabled={record.state === AUTHENTICATION_KEY[1].key}
                size="large"
                className="input-ccus062"
              />
            </Form.Item>
          </div>
        );
      },
      width: 30,
    },
    {
      title: "外国籍",
      render: (_, record) => (
        <Form.Item
          name={[`record${record.key}`, `isForeigner`]}
          valuePropName="checked"
          style={{
            paddingTop: 8,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Checkbox
            disabled={record.state === AUTHENTICATION_KEY[1].key}
          />
        </Form.Item>
      ),
      width: 80,
    },
    {
      title: "氏名",
      render: (_, record) => (
        <FullNameCell
          store={handler.rowErrorStore}
          rowKey={record.key}
          fullName={record.fullName}
          disabled={record.state === AUTHENTICATION_KEY[1].key}
        />
      ),
      width: 180,
    },
    {
      title: "技能者姓①",
      render: (_, record) => (
        <InputCell
          store={handler.rowErrorStore}
          rowKey={record.key}
          field="lastName"
          disabled={record.state === AUTHENTICATION_KEY[1].key}
          width={125}
        />
      ),
      width: 170,
    },
    {
      title: "技能者名①",
      render: (_, record) => (
        <InputCell
          store={handler.rowErrorStore}
          rowKey={record.key}
          field="firstName"
          disabled={record.state === AUTHENTICATION_KEY[1].key}
          width={125}
        />
      ),
      width: 170,
    },
    {
      title: "技能者姓(カタカナ)②",
      render: (_, record) => (
        <InputCell
          store={handler.rowErrorStore}
          rowKey={record.key}
          field="lastNameKatakana"
          disabled={record.state === AUTHENTICATION_KEY[1].key}
          width={125}
        />
      ),
      width: 170,
    },
    {
      title: "技能者名(カタカナ)②",
      render: (_, record) => (
        <InputCell
          store={handler.rowErrorStore}
          rowKey={record.key}
          field="firstNameKatakana"
          disabled={record.state === AUTHENTICATION_KEY[1].key}
          width={125}
        />
      ),
      width: 170,
    },
    {
      title: (
        <div>
          生年月日<span className="sterisk">*</span>
        </div>
      ),
      render: (_, record) => (
        <InputCell
          store={handler.rowErrorStore}
          rowKey={record.key}
          field="dateOfBirth"
          disabled={record.state === AUTHENTICATION_KEY[1].key}
          width="100px"
          maxLength={8}
          placeholder="yyyyMMdd"
          onInput={(e: any) => {
            // Chỉ lọc ký tự; việc báo lỗi do onValuesChange của Form đảm nhiệm
            let { value } = e.target;
            value = value.replace(/[^\d]/g, "");
            if (value.length > 8) {
              value = value.slice(0, 8);
            }
            e.target.value = value;
          }}
        />
      ),
      width: 120,
    },
    {
      title: "認証結果",
      render: (_, record) => {
        return (
          <div style={{ padding: "16px 0px 16px 8px" }}>
            <Form.Item
              name={[`record${record.key}`, `state`]}
              hidden
              style={{ display: "none" }}
            >
              <Input
                disabled={record.state === AUTHENTICATION_KEY[1].key}
                size="large"
                className="input-ccus062"
              />
            </Form.Item>
            <div
              className={`${record.state === AUTHENTICATION_KEY[1].key
                ? "text-state-success"
                : record.state === AUTHENTICATION_KEY[2].key
                  ? "text-state-error"
                  : ""
                }`}
            >
              {record.state === AUTHENTICATION_KEY[1].key ? (
                AUTHENTICATION_KEY[1].value
              ) : record.state === AUTHENTICATION_KEY[2].key ? (
                <div className="record-state-table">
                  <span>{AUTHENTICATION_KEY[2].value}</span>{" "}
                  <img
                    src={IconInfoRed}
                    style={{ cursor: "pointer" }}
                    onClick={() => handler.openModalError(record)}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      },
      width: 130,
    },
  ];
  const rowSelection = {
    selectedRowKeys: handler.selectedRowsKey,
    onChange: (selectedRowKeys: React.Key[]) => {
      handler.getSelectedKey(selectedRowKeys);
    },
    getCheckboxProps: (record: any) => {
      return {
        disabled: record.state === AUTHENTICATION_KEY[1].key,
      };
    },
  };
  return {
    columnsTab1,
    columnsTab2,
    rowSelection,
  };
};
